/* eslint-disable no-prototype-builtins */
import { HubEntityItemWrapper } from 'components/helperStyles'
import React, { memo } from 'react'
import { HubEntityBody } from './HubEntityBody'
import { RootState, Task } from 'constants/interfaces'
import { dateTimeToPercentageDone, formatTimestamp } from 'utils'
import strings from 'constants/strings'
import { useDispatch, useSelector } from 'react-redux'
import { deleteTask } from 'redux/actions/tasks_v2'
import { calculateTaskStatusCounts } from './utils'
import { deriveTaskStatusValue } from 'utils/taskStatusModel'
import { AppDispatch } from 'config/redux'
import { TaskOverviewModal } from 'components/TasksV2/TasksOverview/TaskOverviewModal'
import { useDisclosure } from '@chakra-ui/core'

interface Props {
  task: Task
  uid: string
  isPersonalView?: boolean
  isRsc?: boolean
  selectedTaskID?: string | null
  onTaskSelect?: (tid: string) => void
  onTaskClose?: () => void
}

export const TaskV2ListItem = memo(
  ({ task, uid, isPersonalView = false, isRsc = false, selectedTaskID, onTaskSelect, onTaskClose }: Props) => {
    const {
      title,
      from_ts,
      to_ts,
      deadline,
      created_by,
      tid,
      recurrence_label,
      is_recurring,
      recurrence_ts,
      recurrence_deadline,
      priority,
      hours_until_end,
    } = task

    const dispatch: AppDispatch = useDispatch()
    const localDisclosure = useDisclosure()
    const { userResults, subtasks } = useSelector((state: RootState) => state.tasks_v2)
    const { theme } = useSelector((state: RootState) => state.general)

    // Use external control if provided, otherwise use local state
    const isOpen = selectedTaskID !== undefined ? selectedTaskID === tid : localDisclosure.isOpen

    const statusCounts = calculateTaskStatusCounts(task, subtasks, userResults)
    const taskStatus = deriveTaskStatusValue(statusCounts)

    const startDate = is_recurring ? recurrence_ts : from_ts
    const endDate = is_recurring ? recurrence_deadline : deadline || to_ts

    const outputFormat = theme?.is_support_us_date_format
      ? strings.DATE_FORMATS.outputs.taskPeriodUS
      : strings.DATE_FORMATS.outputs.taskPeriod

    const personalViewOutputFormat = theme?.is_support_us_date_format
      ? strings.DATE_FORMATS.outputs.CREATED_AT_TS_US_FORMAT
      : strings.DATE_FORMATS.outputs.CREATED_AT_TS_FORMAT

    const fromDateFormated = formatTimestamp(
      startDate,
      isPersonalView ? personalViewOutputFormat : outputFormat,
      strings.DATE_FORMATS.inputs.taskPeriod
    )
    const toDateFormated = formatTimestamp(
      endDate,
      isPersonalView ? personalViewOutputFormat : outputFormat,
      strings.DATE_FORMATS.inputs.taskPeriod
    )

    // Use hours_until_end from server (accounts for timezone, allowed_overdue_days, etc.)
    const isOverdue = hours_until_end < 0

    const timelinePercentage = dateTimeToPercentageDone(startDate, endDate)

    const handleDeleteTask = () => {
      dispatch(deleteTask({ tid }))
    }
    const handleOpenTask = async () => {
      if (onTaskSelect) {
        onTaskSelect(tid)
      } else {
        localDisclosure.onOpen()
      }
    }
    const handleCloseTask = () => {
      if (onTaskClose) {
        onTaskClose()
      } else {
        localDisclosure.onClose()
      }
    }
    return (
      <>
        <HubEntityItemWrapper
          onClick={handleOpenTask}
          style={{
            height: isPersonalView ? '60px' : '88px',
            border: isPersonalView ? 'none' : '1px solid #E5E8EB',
            borderRadius: isPersonalView ? '10px' : '12px',
          }}
        >
          <HubEntityBody
            title={title}
            status={taskStatus}
            statusCounts={statusCounts}
            deadline={deadline}
            toDateFormated={toDateFormated}
            recurrence_label={recurrence_label}
            fromDateFormated={fromDateFormated}
            timelinePercentage={timelinePercentage}
            created_by={created_by}
            myUID={uid}
            onOpen={() => console.log('open')}
            handleDelete={handleDeleteTask}
            isOverdue={isOverdue}
            priority={priority}
            isPersonalView={isPersonalView}
            isRsc={isRsc}
          />
        </HubEntityItemWrapper>
        {isOpen && !isPersonalView && <TaskOverviewModal onClose={handleCloseTask} task={task} />}
      </>
    )
  }
)
